import { Box, Tooltip } from '@mui/material';

import { STATUS_PALETTE, StatusToken } from 'src/theme/status-palette';

type Props = {
  label: string;
  /** Optional explanation, shown as a tooltip. The pill becomes focusable so it can be read. */
  note?: string;
  /** Defaults to `neutral`: a calm marker, not an alarm. */
  token?: StatusToken;
};

/**
 * A small caption-sized pill beside a figure's label — "Provvisorio" on the cash cycle's DPO and
 * CCC (NAT-2519), "Oggi" on the snapshot tiles of «Situazione attuale» (NAT-2545). Extracted so
 * both pages mark a figure the same way rather than each carrying its own copy of the recipe.
 */
export default function DashboardPill({ label, note, token = 'neutral' }: Props) {
  const { light, dark } = STATUS_PALETTE[token];

  const pill = (
    <Box
      component="span"
      tabIndex={note ? 0 : undefined}
      sx={{
        display: 'inline-block',
        typography: 'caption',
        ml: 0.75,
        px: 1,
        py: 0.125,
        borderRadius: '99px',
        fontWeight: 'fontWeightMedium',
        whiteSpace: 'nowrap',
        backgroundColor: light.bg,
        color: light.color,
        '[data-color-scheme="dark"] &': {
          backgroundColor: dark.bg,
          color: dark.color,
        },
      }}
    >
      {label}
    </Box>
  );

  return note ? (
    <Tooltip title={note} arrow>
      {pill}
    </Tooltip>
  ) : (
    pill
  );
}
